//App.js => default

//Appel autres fichiers
var $ = require('jquery');
window.$ = window.jQuery = $;

//Appel Boostrap
require('bootstrap');
require('inputmask');

//Autres fichiers
require('./elements/autocomplete');
require('./elements/appearlazy');
require('./elements/HeaderSticky');
require('./elements/HeaderHub');
require('./elements/FooterSticky');
require('./elements/scrollTop');
require('./elements/formStatement');

var loadTooltip = window.loadTooltip = function(e){
    $('[data-bs-toggle="tooltip"]').tooltip({html: true})
};

loadTooltip();

//Filepond
// if ($("#form-statement")[0]){
    FilePond.registerPlugin(
        // encodes the file as base64 data
        FilePondPluginFileEncode,
        FilePondPluginFileValidateSize,
        FilePondPluginFileValidateType,
        FilePondPluginImageExifOrientation
    );
// }

let oldInputs = $('.address_auto');

// We need recall automplete script after switching step (laravel-livewire-wizard)
document.addEventListener('DOMContentLoaded', () => {
    Livewire.hook('message.processed', (message, component) => {
        // Autocomplete adress
        const newInputs = $('.address_auto');

        const countChanged = oldInputs.length !== newInputs.length;
        const diffChanged  = oldInputs.not(newInputs).length > 0 || newInputs.not(oldInputs).length > 0;

        if (countChanged || diffChanged) {
            $('input.address_auto').focus(function() {
                setAdresse(this);
            });
    
            searchAdresses(newInputs);

            oldInputs = newInputs;
        }
    });
});
